<template>
	<div>
		<app-modal-image :content="content" :imageId="imageId" v-if="showModalAddImage"></app-modal-image>
		<el-form @submit.native.prevent="save" ref="form" label-position="top" id="galeria">
			<el-row type="flex" justify="space-between">
				<el-col :span="6">
					<el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
						<el-input v-model="template.title"></el-input>
						<div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
					</el-form-item>
				</el-col>
				<el-col :span="1"></el-col>
				<el-col :span="6">
					<el-form-item label="Tipo de galería">
						<select class="select" v-model="template.tipo">
							<option value="1">Simple</option>
							<option value="2">Múltiple</option>
							<option value="3">Simple con miniaturas</option>
						</select>
					</el-form-item>
				</el-col>
				<el-col :span="1"></el-col>
				<el-col :span="6">
					<el-form-item label="Toggle">
						<el-radio-group v-model="template.toggle">
							<el-radio-button :label="1">Abierto</el-radio-button>
							<el-radio-button :label="2">Cerrado</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row type="flex" justify="space-between">
				<el-col :span="24">
					<el-form-item label="Texto descriptivo de la galería" v-if="showEditor">
						<app-vue-editor :value="template.description"></app-vue-editor>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template v-if="content">
			<button	@click="addImage()" 
					class="el-button el-button--primary">
					<span>Añadir imagen</span> 
					<i class="el-icon-circle-plus"></i>
			</button>
			<br />
			<br />
			<app-modal-draggable v-if="modalDraggable" :content="tableData" :name="'title'" :table="'imagen'"></app-modal-draggable>  
			<app-table-paginate v-if="fecthItems.length > 0"
				:routeEdit="routeEdit" 
				:routeDelete="routeDelete" 
				:tableQuery="fecthItems" 
				:tableColumns="tableColumns" 
				:search="true"
                :draggable="true"
				:move="true">
			</app-table-paginate>
		</template>

	</div>
</template>
<script>
	import ApiService from "@/common/api.service"
	import tablaConPaginador from '@/components/_commons/tablaConPaginador'
	import Image from '@/components/Dashboard/Modals/addImage'
	import tablaConPaginadorVue from '@/components/_commons/tablaConPaginador';
	import { API_UPLOADS } from "@/common/config";
	import Draggable from '@/components/Dashboard/Modals/draggable'
	import Editor from '@/components/_commons/vue-editor'

	
	export default {
		name: "galeria",
		props: ["content"],
		components: {
			'app-table-paginate': tablaConPaginador,
			'app-modal-image': Image,
			'app-modal-draggable': Draggable,
			'app-vue-editor': Editor
		},
		created() {
			this.routeEdit = 'modal'
			this.routeDelete = 'galeriaImagenes'
			if (this.content) {
				this.getTableData()
				this.getContent()
			}

			this.$root.$on('openModal', (id)=> {
				setTimeout(() => {
					this.addImage(id)
				}, 300);
				
			})

			this.$root.$on('closeModal', ()=> {
				this.showModalAddImage = false
				this.getTableData()
			})
			this.$root.$on("saveContent", (id) => {
				this.id = id;
				this.section_id = id
				this.setSave();
			});

            this.$root.$on('galeriaImagenes', (id) => { this.eliminarRegistro(id)})
			this.$root.$on('draggable', (e) => this.showDraggable() )
			this.$root.$on('closeModal', () => this.closeModal() )
			this.$root.$on('vue-editor', (e) => { this.template.description = e})
		},
		watch: {
			$route(to) {
				if (this.content) {
					this.getContent();
				}
			}
		},
		data() {
			return {
				table: "galeria",
				template: {
					title: "",
					description: "",
					toggle: 1,
					tipo: 3
				},
				errorTitle: false,
				message: false,
				id: false,
                tableColumns: [
					{
                       'prop': 'url',
                       'label': 'Imagen' 
                    },
                    {
                       'prop': 'title',
                       'label': 'Título' 
                    }
                ],		
                tableQuery: {},
                tableData: [],
                routeEdit: null,
				deleterow: false,
				showModalAddImage: false,
				api_uploads: API_UPLOADS,
				imageId: false,
				modalDraggable: false,
				showEditor: false
			}
		},
		methods: {
			async getContent() {
				const a = await ApiService.post("dashboard/table", {
					table: "galeria",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					id: this.content
				})
				this.template = a.data
				this.showEditor = true
			},
            async getTableData() {
				this.tableData = []
                const a = await ApiService.post("dashboard/listtablegaleriycontents", {
                    table: 'galeria_imagen',
					token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    galerie_id: this.content
				})
				if(a.status === 200){
                    if(a.data !== 'Algo ha fallado'){
						this.tableData = a.data.filter( (data)=> {
							data.url = this.api_uploads + data.url
							data.move = '/dashboard/' + this.$route.params.db + '/form/edit/imagen/' + data.id
							return data
						})
                    }
				}
            },
			setSave() {
				this.content != 0 ? this.update() : this.insert();
			},
			async update() {
				await ApiService.post("dashboard/editform", {
					table: "galeria",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: this.template,
					id: this.content
				})
			},
			async insert() {
				const a = await ApiService.post("dashboard/editform", {
					table: "galeria",
					token: localStorage.getItem("token"),
					project_id: localStorage.getItem("table"),
					form: this.template
				})
				if(a.status === 200){
					const b = await ApiService.post("dashboard/editform", {
						table: "contents",
						token: localStorage.getItem("token"),
						project_id: localStorage.getItem("table"),
						form: {
							template_id: 4,
							registro_id: a.data
						}
					})
					if(b.status === 200){
						ApiService.post("dashboard/editform", {
							table: "sections_contents",
							token: localStorage.getItem("token"),
							project_id: localStorage.getItem("table"),
							form: {
								section_id: this.section_id,
								content_id: b.data
							}
						})
					}
				}
			},
			addImage(id = null) {
				this.imageId = id				
				this.showModalAddImage = !this.showModalAddImage
			},
			async eliminarRegistro(id) {
                const a = await ApiService.post("dashboard/delete", {
                    table: 'imagen',
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    id: id
                })
				if(a.status === 200){
				  	this.deleterow = a.data
					if(this.deleterow == 1){
						this.$message({
							type: 'success',
							message: 'Se ha eliminado correctamente'
						});
						this.getTableData()
					}else{
						this.$message({
							type: 'warning',
							message: this.deleterow
						});
					}
				} 
			},
			showDraggable() {
                this.modalDraggable = true
            },
            closeModal(){
                this.modalDraggable = false
                this.getTableData()
            }
		},
		computed: {
			fecthItems(){
				return this.tableData
			}
		}
	}
</script>

<style>
	.el-upload__input {
		display: none !important;
	}
	.div-cropper {
		height: 500px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/galeria.vue